import { Box } from '@material-ui/core';
import React from 'react';
import { RouteComponentProps, useHistory } from 'react-router-dom';

import { FixedTab, RouteTabs, VariableTab } from '../../../components/RouteTabs';
import { useVariableTabState } from '../../../hooks/useVariableTabState';
import { IOnboardingFlow } from '../../../services/types';
import { RouteNames } from '../../config';
import FlowList from './FlowList';
import FlowView from './FlowView';

interface IProps {}

const OnboardingFlow = (props: IProps & RouteComponentProps): JSX.Element => {
  const path = RouteNames.OnboardingFlow;
  const [editingIds, setEditingIds] = useVariableTabState(path);
  const history = useHistory();

  const handleRowClick = ({ id }: IOnboardingFlow) => {
    if (!editingIds.includes(id)) {
      setEditingIds(ps => [...ps, id]);
    }
  };

  const handleCreate = () => {
    history.push(RouteNames.OnboardingFlow);
  };

  const handleRemove = (flow: IOnboardingFlow) => {
    history.push(RouteNames.OnboardingFlow);
    handleTabClose(flow.id);
  };

  const getTabLabel = (flowId: number) => String(flowId);

  const getTabUri = (flowId: number) => `v/${flowId}`;

  const handleTabClose = (flowId: number) => {
    setEditingIds(editingIds.filter(id => id !== flowId));
  };

  const keyExtractor = (flowId: number) => `tab-floating-${flowId}`;

  const variableTabRenderer = (flowId: number) => <FlowView flowId={flowId} onCreate={handleCreate} />;

  return (
    <Box>
      <RouteTabs path={path}>
        <FixedTab label="Onboarding Flows">
          <FlowList onRowClick={handleRowClick} onDelete={handleRemove} />
        </FixedTab>
        <FixedTab label="Create an Onboarding Flow" uri="create">
          <FlowView onCreate={handleCreate} />
        </FixedTab>
        <VariableTab<number>
          data={editingIds}
          label={getTabLabel}
          uri={getTabUri}
          onClose={handleTabClose}
          keyExtractor={keyExtractor}
          render={variableTabRenderer}
        />
      </RouteTabs>
    </Box>
  );
};

export default OnboardingFlow;
